/**
 * @typedef IQuestionModel
 * @property {number} id ID pertanyaan
 * @property {string} type Jenis soal
 * @property {string|null} question Text pertanyaan
 * @property {string|null} additional Tcck
 * @property {string|null} additionalQuestion Text pertanyaan tambahan
 * @property {string|null} image Nama gambar
 * @property {string} subjectMatter Materi
 * @property {string[]|null} choices Pilihan jawaban yang tersedia
 * @property {() => IQuestionModel} replaceQuestion
 * @property {() => IQuestionModel} replaceAdditionalQuestion
 * @property {() => IQuestionModel} replaceChoices
 * @property {() => IQuestionModel} setClassForHighlightableImage
 */

/**
 * Question model
 * @param {object} question
 * @returns {IQuestionModel}
 */
export default function QuestionModel(question) {
  this.id = question.id;
  this.question = question.tks;
  this.additionalQuestion = question.ttb;
  this.image = question.gbr;
  this.type = question.jns;
  this.subjectMatter = question.mtr;
  this.additional = question.tcck;

  this.choices = Array.from(Array(5).keys())
    .map((v, i) => question[`pl${i + 1}`])
    .filter((v) => v !== '')
    .filter((v) => v !== null)
    .filter((v) => v !== undefined)
    .map((v) => String(v));

  return this;
}

/**
 * Replace specific character in question
 * @param {string} searchValue
 * @param {string} replaceValue
 * @return {IQuestionModel}
 */
QuestionModel.prototype.replaceQuestion = function replaceQuestion(
  searchValue,
  replaceValue
) {
  this.question = this.question.replaceAll(searchValue, replaceValue);

  return this;
};

/**
 * Replace specific character in additional question
 * @param {string} searchValue
 * @param {string} replaceValue
 * @returns {IQuestionModel}
 */
QuestionModel.prototype.replaceAdditionalQuestion =
  function replaceAdditionalQuestion(searchValue, replaceValue) {
    this.additionalQuestion = this.additionalQuestion.replaceAll(
      searchValue,
      replaceValue
    );

    return this;
  };

/**
 * Replace specific character in all choices
 * @param {string} searchValue
 * @param {string} replaceValue
 * @return {IQuestionModel}
 */
QuestionModel.prototype.replaceChoices = function replaceChoices(
  searchValue,
  replaceValue
) {
  this.choices = this.choices.map((choice) =>
    choice.replaceAll(searchValue, replaceValue)
  );

  return this;
};

/**
 * Add class on image for highlightable
 * @returns {IQuestionModel}
 */
QuestionModel.prototype.setClassForHighlightableImage =
  function setClassForHighlightableImage() {
    this.additionalQuestion = this.additionalQuestion
      .replaceAll('<img', '<img class="image-highlightable"')
      .replaceAll('<IMG', '<IMG class="image-highlightable"');

    this.question = this.question
      .replaceAll('<img', '<img class="image-highlightable"')
      .replaceAll('<IMG', '<IMG class="image-highlightable"');

    return this;
  };
